"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Text_styled_exports = {};
__export(Text_styled_exports, {
  StyledText: () => StyledText
});
module.exports = __toCommonJS(Text_styled_exports);
var import_styled_components = require("styled-components");
var import_styled_components2 = __toESM(require("styled-components"));
var _templateObject;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var StyledText = import_styled_components2.default.p.withConfig({
  displayName: "Textstyled__StyledText",
  componentId: "sc-1xk99mp-0"
})(function(_ref) {
  var theme = _ref.theme, size = _ref.size, weight = _ref.weight, _ref$baseStyle = _ref.baseStyle, baseStyle = _ref$baseStyle === void 0 ? "text1" : _ref$baseStyle, lineHeight = _ref.lineHeight, color = _ref.color, letterSpacing = _ref.letterSpacing, textTransform = _ref.textTransform, darkMode = _ref.darkMode;
  var baseStyleData = {
    heading1: {
      size: "h1",
      weight: "regular",
      lineHeight: "24px"
    },
    heading2: {
      size: "h2",
      weight: "regular",
      lineHeight: "24px"
    },
    heading3: {
      size: "h3",
      weight: "regular",
      lineHeight: "24px"
    },
    title1: {
      size: "huge",
      weight: "black",
      lineHeight: "56px"
    },
    title2: {
      size: "page",
      weight: "black",
      lineHeight: "48px"
    },
    title3: {
      size: "main",
      weight: "regular",
      lineHeight: "40px"
    },
    title4: {
      size: "subtitle",
      weight: "regular",
      lineHeight: "32px"
    },
    title5: {
      size: "minor",
      weight: "regular",
      lineHeight: "16px",
      letterSpacing: "1px",
      textTransform: "uppercase"
    },
    text1: {
      size: "textBase",
      weight: "regular",
      lineHeight: "24px"
    },
    text2: {
      size: "textSmall",
      weight: "regular",
      lineHeight: "20px"
    }
  };
  var styleType = baseStyle.includes("heading") ? "headings" : baseStyle.includes("title") ? "titles" : baseStyle.includes("text") ? "textStyles" : "textStyles";
  var letterSpacingStyle = letterSpacing || (baseStyle.includes("title5") ? baseStyleData.title5.letterSpacing : "inherit");
  var textTransformStyle = textTransform || (baseStyle.includes("title5") ? baseStyleData.title5.textTransform : "none");
  return (0, import_styled_components.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      font-family: ", ";\n\n      font-size: ", "\n\n      font-weight: ", "\n\n      line-height: ", "\n\n      color: ", "\n\n      letter-spacing: ", ";\n      text-transform: ", ";\n      margin-block: 0;\n      "])), theme.typography.fonts.primary, size ? "".concat(theme.typography.sizes[size], ";") : "".concat(theme.typography[styleType][baseStyleData[baseStyle].size], ";"), weight ? "".concat(theme.typography.weights[weight], ";") : "".concat(theme.typography.weights[baseStyleData[baseStyle].weight], ";"), lineHeight ? "".concat(lineHeight, ";") : "".concat(baseStyleData[baseStyle].lineHeight, ";"), color ? "".concat(color, ";") : darkMode ? "".concat(theme.colors.white, ";") : "inherit", letterSpacingStyle, textTransformStyle);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledText
});
//# sourceMappingURL=Text.styled.js.map